export default __webpack_public_path__ + "static/media/16.0e36c29e.jpg";